/**
 * mm-constants.js
 *
 * Defensive shims the rest of the MM cart stack builds on. Every definition is
 * guarded so a host theme that already ships its own implementation keeps it.
 * Must load before mm-cart.js / mm-cart-intercept.js / mm-cart-drawer.js.
 */
(function () {
  window.theme = window.theme || {};

  if (!theme.pubsub) {
    const subscribers = {};

    theme.pubsub = {
      PUB_SUB_EVENTS: {
        cartUpdate: 'cart-update',
        quantityUpdate: 'quantity-update',
        variantChange: 'variant-change',
        cartError: 'cart-error',
      },

      subscribe(eventName, callback) {
        if (!subscribers[eventName]) subscribers[eventName] = [];
        subscribers[eventName].push(callback);

        return function unsubscribe() {
          subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
        };
      },

      publish(eventName, data) {
        (subscribers[eventName] || []).forEach((callback) => {
          try {
            callback(data);
          } catch (error) {
            console.error('[mm-cart] subscriber failed for "' + eventName + '"', error);
          }
        });
      },
    };
  }

  if (!theme.utils) theme.utils = {};

  if (!theme.utils.debounce) {
    theme.utils.debounce = function (fn, wait) {
      let timer;
      return function debounced(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
      };
    };
  }

  if (!theme.utils.fetchConfig) {
    theme.utils.fetchConfig = function (type = 'json', method = 'POST') {
      return {
        method,
        headers: {
          'Content-Type': 'application/json',
          Accept: `application/${type}`,
        },
      };
    };
  }
})();
